import { CSSProperties, ElementType, FC, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './Typography.module.css';

interface TitleProps {
	level?: 1 | 2 | 3;
	className?: string;
	children?: ReactNode;
}

const Title: FC<TitleProps> = ({ level = 3, className = ``, children }) => {
	const Tag: ElementType = `h${level}` as ElementType;

	return <Tag className={classNames(styles[`heading-${level}`], className)}>{children}</Tag>;
};

interface TextProps {
	variant?: 'body' | 'note' | 'regular' | 'menu' | 'button-sm' | 'button-md' | 'button-lg' | 'note-2';
	as?: ElementType;
	children?: ReactNode;
	className?: string;
	style?: CSSProperties;
}

const Text: FC<TextProps> = ({ variant = `body`, as: Tag = `p`, className = ``, children, style }) => (
	<Tag className={classNames(styles[`text-${variant}`], className)} style={style}>
		{children}
	</Tag>
);

export const Typography = { Title, Text };
